import React from "react";
import { Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LogIn } from "@scenes/logIn";
import { Props } from "./types";
import styles from "./styles.scss";
import logo from "./logo.png";

function LandingPage(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.landingPage}>
      <div className={styles.header}>
        <img className={styles.logo} src={logo} alt="Augeo Logo" />
      </div>
      <div className={styles.main}>
        <Routes>
          <Route
            path="/log-in"
            element={
              <div className={styles.logIn}>
                <LogIn />
              </div>
            }
          />
          <Route
            path="*"
            element={
              <div className={styles.logIn}>
                <LogIn />
              </div>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export { LandingPage };
